<div class="vertical-stack-32">
    <div class="m-form__group">
        <h2 class="section-title mb-20" data-test-id="authorized-user.title">{{isYouthAccount ? 'Parent/Guardian' : contentService.getContentText('AUTHORIZED_USER_TEXT')}} Information</h2>
        <form #f="ngForm" data-test-id="authorized-user.form">
            <div class="row">
                <!--  showMiddleName variable drives layout -->
                <div [class]="cssWidthClass" [class.col-sm-4]="!institutionSettings.singleColumnLayout && appConfig.showMiddleName" [class.{{cssWidthClass}}]="!institutionSettings.singleColumnLayout && !appConfig.showMiddleName">
                    <mat-form-field class="mat-form-field-fluid">
                        <mat-label data-test-id="authorized-user.first-name-label">First Name</mat-label>
                        <input matInput type="text" alphabetWithSpace name="coborrowerFirstName"
                            [(ngModel)]="applicant.firstName"
                            #coborrowerFirstName="ngModel" required
                            data-test-id="authorized-user.first-name-input">
                        <mat-error data-test-id="authorized-user.first-name.required-error">Please enter the first name.</mat-error>
                        <mat-hint data-test-id="authorized-user.first-name-hint">Must match with name on ID you plan to use for verification</mat-hint>
                    </mat-form-field>
                </div>

                <div *ngIf="appConfig.showMiddleName" [class]="cssWidthClass" [class.col-sm-4]="!institutionSettings.singleColumnLayout && appConfig.showMiddleName"
                    [class.{{cssWidthClass}}]="!institutionSettings.singleColumnLayout && !appConfig.showMiddleName">
                    <mat-form-field class="mat-form-field-fluid">
                        <mat-label data-test-id="authorized-user.middle-name-label">Middle Name</mat-label>
                        <input matInput type="text" alphabetWithSpace name="coborrowerMiddleName"
                            [(ngModel)]="applicant.middleName"
                            #coborrowerMiddleName="ngModel"
                            data-test-id="authorized-user.middle-name-input">
                        <mat-error data-test-id="authorized-user.middle-name.required-error">Please enter the middle name.</mat-error>
                    </mat-form-field>
                </div>
                <div [class]="cssWidthClass" [class.col-sm-4]="!institutionSettings.singleColumnLayout && appConfig.showMiddleName" [class.{{cssWidthClass}}]="!institutionSettings.singleColumnLayout && !appConfig.showMiddleName">
                    <mat-form-field class="mat-form-field-fluid">
                        <mat-label data-test-id="authorized-user.last-name-label">Last Name</mat-label>
                        <input matInput type="text" name="coborrowerLastName"
                            [(ngModel)]="applicant.lastName"
                            #coborrowerLastName="ngModel" required alphabetWithSpace
                            data-test-id="authorized-user.last-name-input">
                        <mat-error data-test-id="authorized-user.last-name.required-error">Please enter the last name.</mat-error>
                    </mat-form-field>
                </div>
                <div [class]="cssWidthClass">
                    <mat-form-field class="mat-form-field-fluid">
                        <mat-label data-test-id="authorized-user.email-label">{{isYouthAccount ? 'Parent/Guardian' : contentService.getContentText('AUTHORIZED_USER_TEXT')}}'s e-mail</mat-label>
                        <input matInput type="text" name="coborrowerEmail"
                            [(ngModel)]="applicant.email"
                            #coborrowerEmail="ngModel" required min-max
                            data-test-id="authorized-user.email-input">
                        <mat-error *ngIf="coborrowerEmail.hasError('required')" data-test-id="authorized-user.email.required-error">Please enter an email address.
                        </mat-error>
                        <mat-error *ngIf="coborrowerEmail.hasError('email')" data-test-id="authorized-user.email.invalid-error">Please enter a valid email address.
                        </mat-error>
                        <mat-error *ngIf="coborrowerEmail.hasError('duplicateEmail')" data-test-id="authorized-user.email.duplicate-error">Please use a different email than the primary applicant.
                        </mat-error>
                    </mat-form-field>
                </div>
                <div [class]="cssWidthClass">
                    <creditsnap-phone-number [(ngModel)]="applicant.primaryPhone" [label]="(isYouthAccount ? 'Parent/Guardian' : contentService.getContentText('AUTHORIZED_USER_TEXT'))+ '\'s Mobile Number'"
                                            #coborrowerPhone="ngModel" name="coborrowerPhone" required
                                            [id]="'coapplicant-phone-number'"
                                            data-test-id="authorized-user.phone-number"></creditsnap-phone-number>
                </div>

                <ng-container *ngIf="miscellaneousFieldsConfig">
                    <div [class]="cssWidthClass" *ngIf="miscellaneousFieldsConfig.ssn">
                        <creditsnap-ssn #ssn [(ngModel)]="applicant.ssn" #coborrowerSsn="ngModel" name="coborrowerSsn"
                                        data-test-id="authorized-user.ssn"></creditsnap-ssn>
                    </div>
                    <ng-container *ngIf="miscellaneousFieldsConfig.mothersMaidenNameCobo">
                        <div [class]="cssWidthClass">
                            <mat-form-field class="mat-form-field-fluid">
                                <mat-label data-test-id="authorized-user.mothers-maiden-name-label">Mother's Maiden Name</mat-label>
                                <input matInput type="text" name="coborrowerMothersMaidenName"
                                    autocomplete="off" alphabetOnly
                                    [(ngModel)]="applicant.mothersMaidenName" #coborrowerMothersMaidenName="ngModel"
                                    required
                                    data-test-id="authorized-user.mothers-maiden-name-input">
                                <mat-error data-test-id="authorized-user.mothers-maiden-name.required-error">Please enter mother's maiden name.</mat-error>
                            </mat-form-field>
                        </div>
                    </ng-container>
                </ng-container>

                <div [class]="cssWidthClass">
                    <creditsnap-date #dob [(ngModel)]="applicant.dateOfBirth" name="coborrowerDateOfBirth"
                                    [minDate] ="minDobDate" [maxDate]="maxDobDate"
                                    data-test-id="authorized-user.date-of-birth"></creditsnap-date>
                </div>

                <div class="{{cssWidthClass}}"
                    *ngIf="appConfig?.citizenshipOptions.length > 0">
                    <mat-form-field class="mat-form-field-fluid">
                        <mat-label data-test-id="authorized-user.citizenship-label">Select your citizen status</mat-label>
                        <mat-select name="citizenInd" [(ngModel)]="coBoCitizenInd" required (selectionChange)="onCitizenShipChange($event)"
                                    data-test-id="authorized-user.citizenship-select">
                            <mat-option *ngFor="let eligibility of appConfig?.citizenshipOptions"
                                        [value]="eligibility.value" id="{{eligibility.value}}"
                                        [attr.data-test-id]="'authorized-user.citizenship-option.' + eligibility.value?.toLowerCase()"> {{eligibility.label}}
                            </mat-option>
                        </mat-select>
                        <mat-error data-test-id="authorized-user.citizenship.required-error">Please select citizenship status.</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </div>

    <ng-container *ngIf="finalSubmitPageConfig.collectID">
        <cs-identity-info #identityInfo [(ngModel)]="applicant" name="coborrowerApplicant" data-test-id="authorized-user.identity-info"></cs-identity-info>
    </ng-container>

    <!-- Employment history-->
    <ng-container *ngIf="finalSubmitPageConfig.employmentHistory">
        <cs-employment-info #employmentInfo [applicant]="applicant" data-test-id="authorized-user.employment-info"></cs-employment-info>
    </ng-container>

    <!-- Residence history-->
    <ng-container *ngIf="finalSubmitPageConfig.residencyHistory || appConfig.coBoMailingAddress">
        <cs-residence-info class="vertical-stack-32"  #residenceInfo [applicant]="applicant" [primaryApplicant]="primaryApplicant" [isCoBo]="true" data-test-id="authorized-user.residence-info"></cs-residence-info>
    </ng-container>
</div>
